import styled from 'styled-components'

function BaseRotateRightIcon({ className, size = 24 }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.7266 10.5H22.125C22.7484 10.5 23.25 9.99844 23.25 9.375V3.375C23.25 2.92031 22.9781 2.50781 22.5562 2.33437C22.1344 2.16094 21.6516 2.25469 21.3281 2.57812L19.3781 4.52812C15.2719 0.473438 8.65781 0.4875 4.575 4.575C0.473434 8.67656 0.473434 15.3234 4.575 19.425C8.67656 23.5266 15.3234 23.5266 19.425 19.425C20.0109 18.8391 20.0109 17.8875 19.425 17.3016C18.8391 16.7156 17.8875 16.7156 17.3016 17.3016C14.3719 20.2312 9.62343 20.2312 6.69375 17.3016C3.76406 14.3719 3.76406 9.62344 6.69375 6.69375C9.60937 3.77813 14.3203 3.76406 17.2547 6.64687L15.3281 8.57812C15.0047 8.90156 14.9109 9.38437 15.0844 9.80625C15.2578 10.2281 15.6703 10.5 16.125 10.5H21.7266Z"
        fill="currentColor"
      />
    </svg>
  )
}

export const RotateRightIcon = styled(BaseRotateRightIcon)``
